import { RefObject, useEffect } from 'react';

const POLLING_MS = 100;

/** Polls an imperative ref until it first gets a value, then calls the onReady function. */
export const useWaitForImperativeRef = <T>(
  imperativeRef: RefObject<T>,
  onReady: Function
) => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (imperativeRef.current) {
        onReady();
        clearInterval(interval);
      }
    }, POLLING_MS);

    return () => clearInterval(interval);
  }, [imperativeRef, onReady]);
};
